import { useState, useEffect } from 'react';
import { getAllInstructorWage } from '../api/instructor';

const useInstructorWages = (storeId, wageDate) => {
  const [instructorWageList, setInstructorWageList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (storeId) {
          const data = await getAllInstructorWage(storeId, wageDate);
          setInstructorWageList(data);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [storeId, wageDate]);

  return { instructorWageList, loading, error };
};

export default useInstructorWages;
